module.exports = __webpack_public_path__ + "img/img_6.f2f63519.png";